import { Form } from "@circle-react-uikit/Form";

import { t } from "@/i18n-js/instance";
import {
  COURSE_TYPE_FIELD_NAME,
  CourseTypePickerRadioGroup,
  type CourseTypeFieldName,
  getCourseTypeRules,
} from "@/react/components/CoursesV2/CourseTypePickerRadioGroup";

interface CourseTypePickerOptionsProps {
  hideLabel?: boolean;
  isFirstChild?: boolean;
  name?: CourseTypeFieldName;
  shouldConfirmChange?: boolean;
}

export const CourseTypePickerOptions = ({
  hideLabel,
  isFirstChild,
  name = COURSE_TYPE_FIELD_NAME,
  shouldConfirmChange = false,
}: CourseTypePickerOptionsProps) => {
  const rules = getCourseTypeRules();

  return (
    <Form.Item
      name={name}
      hideDescription
      rules={rules}
      hideBorder
      fullWidth
      isFirstChild={isFirstChild}
      variant="extra-bottom-margin"
      label={t("spaces.form.create.course_types.label")}
      hideLabel={hideLabel}
      shouldForceV4FormItem
    >
      <CourseTypePickerRadioGroup
        name={name}
        rules={rules}
        shouldConfirmChange={shouldConfirmChange}
      />
    </Form.Item>
  );
};
